import React, { useEffect, useState, useRef } from 'react';
import useGlobal from '../../store';
import GiftIdeaCard from '../Gift/GiftIdeaCard';
import LoadingOverlay from './../General/LoadingOverlay';
import SelectFilter from './../General/SelectFilter';
import InfiniteScroll from 'react-infinite-scroller';
import { Spinner } from 'reactstrap';


const GiftIdeasPanel = (props) => {

    const scrollParentRef = useRef(null);

    const [isLoading, setIsLoading] = useState(false);
    const [hasMoreGiftIdeas, setHasMoreGiftIdeas] = useState(false);
    const [searchParams, setSearchParams] = useState({ price_low: 0, pg: 1 });

    const [giftideas, giftideaActions] = useGlobal(
        state => state.giftideas,
        actions => actions.giftideaActions
    );

    const [response, userActions] = useGlobal(
        state => state.response,
        actions => actions.userActions
    );

    const items = giftideas.map(item => <GiftIdeaCard key={item.id} {...item} user={props.user}></GiftIdeaCard>);

    useEffect(() => {
        let params = {
            price_low: 0,
            pg: 1
        };
        if(props.user) {
            params = {
                age: props.user.ageRange,
                gender: props.user.gender,
                price_low: 0,
                pg: 1
            }
        }
        setSearchParams(params);
        giftideaActions.search(params, true);
        setIsLoading(true);
    }, [giftideaActions, props.user])

    useEffect(() => {
        setIsLoading(false);
        if(!giftideas) {
            setHasMoreGiftIdeas(false);
            return;
        }

    }, [giftideas]);

    useEffect(() => {
        if(response && response.type === "searchgiftideas") {
            if(!response.data || response.data.length === 0) {
                setHasMoreGiftIdeas(false);
            } else {
                setHasMoreGiftIdeas(true);
            }
            return;
        }
    }, [response]);

    const selectedFilterChanged = (chosenFilter) => {
        console.log('NEW SELECTED FILTER', chosenFilter);
        let existingSearchParams = searchParams;
        existingSearchParams.pg = 1;
        if(genderOptions.indexOf(chosenFilter) >= 0) {
            existingSearchParams.gender = chosenFilter;
            setSearchParams(existingSearchParams);
        } else if(ageOptions.indexOf(chosenFilter) >= 0) {
            existingSearchParams.age = chosenFilter;
            setSearchParams(existingSearchParams);
        } else if(priceRangeOptions.indexOf(chosenFilter) >= 0) {
            switch (chosenFilter) {
                case "all prices":
                    delete existingSearchParams.price_high;
                    break;
                case "under " + userActions.getUserCurrencySymbol() + "100":
                    existingSearchParams.price_high = 100;
                    break;
                case "under " + userActions.getUserCurrencySymbol() + "50":
                    existingSearchParams.price_high = 50;
                    break;
                case "under " + userActions.getUserCurrencySymbol() + "20":
                    existingSearchParams.price_high = 20;
                    break;
                default:
                    break;
            }
            setSearchParams(existingSearchParams);
        }
        refreshGiftIdeas();
    }
    
    const refreshGiftIdeas = () => {
        giftideaActions.search(searchParams, true);
        setIsLoading(true);
    }

    const genderOptions = ['both', 'male', 'female'];
    const ageOptions = ['all ages', 'baby', 'toddler', 'child', 'teen', 'young-adult', 'adult', 'senior'];
    const priceRangeOptions = ['all prices', 
        'under ' + userActions.getUserCurrencySymbol() + '100', 
        'under ' + userActions.getUserCurrencySymbol() + '50', 
        'under ' + userActions.getUserCurrencySymbol() + '20'];

    const loadFunc = (page) => {
        console.log('LOAD MORE SIDE PANEL', page);
        setHasMoreGiftIdeas(false);
        let params = searchParams;
        params.pg = params.pg + 1;
        setSearchParams(params);
        giftideaActions.search(params, true);
    }
    return (
        <>
            <div className="kt-portlet">
                <div style={{flexWrap:"wrap", padding: "6px 20px"}} className="kt-portlet__head kt-portlet__head--lg">
                    <div className="kt-portlet__head-toolbar">
                        <SelectFilter selected={props.user ? props.user.gender : null} options={genderOptions} onChange={selectedFilterChanged} className="mr-1"></SelectFilter>
                        <SelectFilter selected={props.user ? props.user.ageRange : null} options={ageOptions} onChange={selectedFilterChanged} className="mr-1"></SelectFilter>
                        <SelectFilter options={priceRangeOptions} onChange={selectedFilterChanged}></SelectFilter>
                    </div>
                </div>
   
                <div className="kt-portlet__body gift-idea-block" ref={scrollParentRef} style={{background:"#efeae5"}}>
                    { isLoading ? <LoadingOverlay></LoadingOverlay> : <></>}
                    <InfiniteScroll
                        pageStart={0}
                        loadMore={loadFunc}
                        hasMore={hasMoreGiftIdeas}
                        threshold={40}
                        loader={<Spinner key={0}></Spinner>}
                        useWindow={false}
                        getScrollParent={() => props.scrollRef}
                    >
                        <div className="grid-card-wrapper mobile">
                            {items}
                        </div>
                    </InfiniteScroll>
                </div>
            </div>
        
        </>);
}
export default GiftIdeasPanel;